type AssignedDivision = { id: string };

const getAssignedDivisionIds = (
  assignedDivisions: Record<string, AssignedDivision> | AssignedDivision[] | null | undefined,
): string[] => {
  if (!assignedDivisions) {
    return [];
  }

  if (Array.isArray(assignedDivisions)) {
    return assignedDivisions.map(division => division.id);
  }

  return Object.values(assignedDivisions).map(division => division.id);
};

export const areAllDivisionsSelected = (
  selectedIds: string[] | undefined,
  assignedDivisions: Record<string, AssignedDivision> | AssignedDivision[] | null | undefined,
): boolean => {
  const assignedIds = getAssignedDivisionIds(assignedDivisions);

  if (!assignedIds.length) {
    return false;
  }

  const selected = selectedIds ?? [];
  if (selected.length !== assignedIds.length) {
    return false;
  }

  const selectedSet = new Set(selected);
  return assignedIds.every(id => selectedSet.has(id));
};
